import React, { useContext } from 'react'
import styles from './NextButton.module.css'
import { StepContext } from '../../../Steps/StepContainer'
import {
    HandleDisplayValuesFunction,
    HandleMultipleFormValuesFunction,
    HandleUserResumesFunction,
    NextButtonProps,
    UserResumeKeys,
    UserResumeValues,
} from './types'
import {
    FormValues,
    UserResume,
} from '../../../Store/reducers/formReducer/types'

export const NextButton = ({
    formKey,
    formValue,
    displayFormKey,
    displayFormValue,
    isDisabled,
    confirmation = '次へ',
    onSubmit,
    dataClickLabel,
    isLoading = false,
}: NextButtonProps) => {
    const { handleNext, setFormValue, updateUserResume, setDisplayValue } =
        useContext(StepContext)

    const handleUserResumes: HandleUserResumesFunction = (keys, values) => {
        const index = values[0]
        for (let i = 1; i < keys.length; i++) {
            updateUserResume(index, keys[i] as keyof UserResume, values[i])
        }
    }

    const handleMultipleFormValues: HandleMultipleFormValuesFunction = (
        keys,
        values
    ) => {
        keys.forEach((key, index) => {
            setFormValue(key, values[index])
        })
    }

    const handleDisplayValues: HandleDisplayValuesFunction = (keys, values) => {
        keys.forEach((key, index) => {
            setDisplayValue(key, values[index])
        })
    }

    const updateDisplayValues = () => {
        if (displayFormKey === undefined || displayFormValue === undefined)
            return

        if (Array.isArray(displayFormKey) && Array.isArray(displayFormValue)) {
            handleDisplayValues(displayFormKey, displayFormValue)
        } else {
            setDisplayValue(displayFormKey, displayFormValue)
        }
    }

    const updateFormValues = () => {
        if (formKey === undefined) return

        if (!Array.isArray(formKey)) {
            setFormValue(formKey, formValue as string | number | number[])
            return
        }

        if (
            formKey[0] === 'userResumesAttributes' &&
            Array.isArray(formValue)
        ) {
            handleUserResumes(
                formKey as UserResumeKeys,
                formValue as UserResumeValues
            )
        } else if (Array.isArray(formValue)) {
            handleMultipleFormValues(
                formKey as (keyof FormValues)[],
                formValue as (string | number | null | number[])[]
            )
        }
    }

    const handleClick = () => {
        if (isLoading) return

        updateDisplayValues()
        updateFormValues()

        if (onSubmit) {
            onSubmit()
        } else {
            handleNext()
        }
    }

    return (
        <div>
            <button
                data-click-label={dataClickLabel}
                className={`${styles.NextButton} ${isDisabled ? styles.disabled : ''}`}
                onClick={handleClick}
                disabled={isDisabled || isLoading}
            >
                {isLoading ? (
                    <div className={styles.loadingSpinner}>
                        <div className={styles.spinner}></div>
                    </div>
                ) : (
                    <>
                        <span className={styles.ButtonText}>
                            {confirmation}
                        </span>
                        <img
                            src={'/foodslaboEf/img/common/nextIcon.svg'}
                            alt={'次へボタンアイコン'}
                        />
                    </>
                )}
            </button>
        </div>
    )
}
